import { generatePath } from 'react-router-dom';
import { API_URLS } from '../../../routes/urls';
import { convertObjectToFormData } from '../../../utils/form';
import { apiSlice } from '../../apiSlice';
import { BaseQueryError } from '../../types';
import { formatApplyDataForProgramsOrScholarshipsRequest } from './helper';
import { ApplyForProgramsOrScholarshipsRequestPayload, ApplyForProgramsOrScholarshipsResponse } from './types';
import { userApi } from '../user/userSlice';

const applyApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    applyForProgramsOrScholarships: builder.mutation<
      ApplyForProgramsOrScholarshipsResponse,
      ApplyForProgramsOrScholarshipsRequestPayload
    >({
      queryFn: async ({ user_id, items, type, slug }, { dispatch }, _extraOptions, baseQuery) => {
        const { apply, secondary_apply, has_program } = formatApplyDataForProgramsOrScholarshipsRequest(items);
        const applyResult = await baseQuery({
          url: generatePath(API_URLS.applyForProgramsOrScholarships, { slug }),
          method: 'POST',
          data: convertObjectToFormData({
            type,
            user_id,
            apply,
            secondary_apply,
            has_program,
          }),
        });

        if (applyResult.data) {
          const data = applyResult.data as ApplyForProgramsOrScholarshipsResponse;
          // Updating student application data in case of successful apply
          if (data.success && 'data' in data) {
            dispatch(
              userApi.util.updateQueryData('getProfile', { slug, userId: user_id }, (draft) => {
                draft.user = data.data.student;
              })
            );
          }
          return { data };
        } else {
          return { error: applyResult.error as BaseQueryError };
        }
      },
    }),
  }),
});

export const { useApplyForProgramsOrScholarshipsMutation } = applyApi;
